import { render, staticRenderFns } from "./mtflow.vue?vue&type=template&id=06de7f94&scoped=true&lang=pug&"
import script from "./mtflow.vue?vue&type=script&lang=js&"
export * from "./mtflow.vue?vue&type=script&lang=js&"
import style0 from "./mtflow.vue?vue&type=style&index=0&id=06de7f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de7f94",
  null
  
)

export default component.exports